import { Dropdown } from "react-bootstrap";
import { OrderSummary } from "../../../types/Order/orderSummary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { OrderStatus } from "../../../constant/Order/OrderStatus";

interface OrderDropdownToggleProps {
  viewDetails: (orderId: string) => void;
  continueOrder: (orderId: string) => void;
  viewInvoice: (invoiceUrl: string) => void;
  assignOrder: (orderId: string) => void;
  value: OrderSummary;
}

const OrderTableDropdown = ({
  value,
  viewDetails,
  continueOrder,
  viewInvoice,
  assignOrder,
}: OrderDropdownToggleProps) => {
  return (
    <Dropdown className="bg-white">
      {" "}
      <Dropdown.Toggle id="dropdown-basic">
        <FontAwesomeIcon icon={faEllipsisV} />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item
          onClick={() => viewDetails(value.id)}
          eventKey={1}
          key={1}>
          {"View Details"}
        </Dropdown.Item>

        {value.status === OrderStatus.NEW && (
          <Dropdown.Item
            onClick={() => continueOrder(value.id)}
            eventKey={2}
            key={2}>
            {"Continue Order"}
          </Dropdown.Item>
        )}

        {value.invoiceUrl && (
          <Dropdown.Item
            onClick={() => viewInvoice(value.invoiceUrl!)}
            eventKey={3}
            key={3}>
            {"View Invoice"}
          </Dropdown.Item>
        )}

        {value.organisationId === 0 && value.fulfilled !== null && (
          <Dropdown.Item
            onClick={() => assignOrder(value.id)}
            eventKey={4}
            key={4}>
            Assign to Customer
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default OrderTableDropdown;
